<template>
  <div class="mint">
    <div class="text-xl md:text-2xl text-center mt-16 px-4 md:px-0">
      <div class="text-3xl">Mint an vNFT</div>
      <div class="text-red-500"></div>
    </div>
    <div
      class="flex flex-col md:flex-row md:space-x-10 md:justify-center items-start mt-6 text-center"
      style=""
    >
      <MintComponent />
      <StakeComponent />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Number from "@/components/Number.vue";
import StakeComponent from "@/components/farm/Stake.vue";
import MintComponent from "@/components/farm/Mint.vue";

export default {
  name: "Farm",
  components: {
    Number,
    StakeComponent,
    MintComponent,
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  created: function () {},
  methods: {},
};
</script>
